import { render, staticRenderFns } from "./DistrictSelector.vue?vue&type=template&id=616e9d48&lang=pug&"
import script from "./DistrictSelector.vue?vue&type=script&lang=ts&"
export * from "./DistrictSelector.vue?vue&type=script&lang=ts&"
import style0 from "./DistrictSelector.vue?vue&type=style&index=0&id=616e9d48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports